import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-export\">\n<path d=\"M91.1,153.9h-5.4C37.4,97,68.8,59,116.5,31.8l-14-24.3c-1.1-1.6-1.1-3.8,0-5.4c1.1-1.7,3.2-2.5,5.2-2l73.1,11.7\n\tc2.6,0.7,4.1,3.4,3.5,6L158,86.4c-0.3,1.2-1.1,2.3-2.2,2.9H154c-1.9,0.2-3.8-0.8-4.8-2.5l-14-23.4C88.3,90.2,71.8,115.8,91.1,153.9z\n\t M169.2,200H30.8C13.8,200,0,186.2,0,169.3v-123c0-17,13.8-30.7,30.8-30.7h30.8V30H30.8c-8.5,0-15.4,6.9-15.4,15.4v124.8\n\tc0,8.5,6.9,15.4,15.4,15.4h0h138.5c8.5,0,15.4-6.9,15.4-15.4l0,0V92.4H200v76.9C200,186.2,186.2,200,169.2,200z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/export.svg
// module id = gmuv
// module chunks = 27